import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-id",
  "use": "icon-icon-id-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-id\">\n  <path fill=\"#e70011\" d=\"M0 0h512v256H0Z\" />\n  <path fill=\"#fff\" d=\"M0 256h512v256H0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol